module.exports = __webpack_public_path__ + "static/media/vip-message-background.abe195aa.png";